export const iconFontAwesomeMathematicsMinus = (
	<i className="fa-solid fa-minus"></i>
);
